import { authService } from "~/utils/api/authService";

export default defineNuxtRouteMiddleware(async () => {
  if (!document.cookie.includes("XSRF-TOKEN")) {
    await authService.getCsrf();
  }
});
